import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useCallback } from 'react';
import { z } from 'zod';
import { ClientsList, type ClientsSearch } from '../../../features/B4/ClientsList';

const searchSchema = z.object({
  tenant: z.string().trim().max(64).optional().catch(undefined),
  status: z.enum(['draft', 'active', 'paused']).optional().catch(undefined),
  q: z.string().max(120).optional().catch(undefined),
});

/** #/clients[?tenant=<slug>&status=&q=] — clients list (mockups/assets/screens/clients.js). */
export const Route = createFileRoute('/_app/clients/')({
  validateSearch: searchSchema,
  component: ClientsPage,
});

function ClientsPage() {
  const search = Route.useSearch();
  const navigate = useNavigate({ from: '/clients/' });
  const onSearch = useCallback(
    (s: ClientsSearch) => void navigate({ search: { tenant: s.tenant || undefined, status: s.status, q: s.q || undefined }, replace: true }),
    [navigate],
  );
  return <ClientsList search={search} onSearch={onSearch} />;
}
